import { Observable } from 'rxjs/Rx'
import { combineEpics } from 'redux-observable'
import {
  operate,
  operatorCourierTransition,
  operatorTransition,
  modify,
  calculateRoutingETA,
  updateEstimatedArrivalTime,
  billableToBilled,
} from 'store/services/delivery'
import { alertError, alertSuccess } from 'store/ducks/alert'
import { deleteSegment, split } from '../services/delivery'
import { parseDeliverySplitPayload } from '../utils/delivery'

export const DELIVERIES_REQUEST = 'operations/DELIVERIES_REQUEST'
export const DELIVERIES_SUCCESS = 'operations/DELIVERIES_SUCCESS'
export const DELIVERIES_FAILURE = 'operations/DELIVERIES_FAILURE'
export const DELIVERIES_UPDATE = 'operations/DELIVERIES_UPDATE'
export const DELIVERIES_DELETE = 'operations/DELIVERIES_DELETE'
export const DELIVERY_COURIER_TRANSITION_REQUEST = 'operations/DELIVERY_COURIER_TRANSITION_REQUEST'
export const DELIVERY_COURIER_TRANSITION_SUCCESS = 'operations/DELIVERY_COURIER_TRANSITION_SUCCESS'
export const DELIVERY_COURIER_TRANSITION_FAILURE = 'operations/DELIVERY_COURIER_TRANSITION_FAILURE'
export const DELIVERY_TRANSITION_REQUEST = 'operations/DELIVERY_TRANSITION_REQUEST'
export const DELIVERY_TRANSITION_SUCCESS = 'operations/DELIVERY_TRANSITION_SUCCESS'
export const DELIVERY_TRANSITION_FAILURE = 'operations/DELIVERY_TRANSITION_FAILURE'
export const DELIVERY_MODIFY = 'operations/DELIVERY_MODIFY'
export const DELIVERY_MODIFY_SUCCESS = 'operations/DELIVERY_MODIFY_SUCCESS'
export const DELIVERY_MODIFY_FAILURE = 'operations/DELIVERY_MODIFY_FAILURE'
export const DELIVERY_MODIFY_ADRESSES = 'operations/DELIVERY_MODIFY_ADRESSES'
export const DELIVERY_MODIFY_ADRESSES_SUCCESS = 'operations/DELIVERY_MODIFY_ADRESSES_SUCCESS'
export const DELIVERY_MODIFY_ADRESSES_FAILURE = 'operations/DELIVERY_MODIFY_ADRESSES_FAILURE'
export const DELIVERY_BOARD_MODIFY = 'operations/DELIVERY_BOARD_MODIFY'
export const DELIVERY_BOARD_MODIFY_SUCCESS = 'operations/DELIVERY_BOARD_MODIFY_SUCCESS'
export const DELIVERY_BOARD_SPLIT = 'operations/DELIVERY_BOARD_SPLIT'
export const DELIVERY_BOARD_SPLIT_SUCCESS = 'operations/DELIVERY_BOARD_SPLIT_SUCCESS'
export const DELIVERY_BOARD_SPLIT_FAILURE = 'operations/DELIVERY_BOARD_SPLIT_FAILURE'
export const DELIVERY_BOARD_DELETE = 'operations/DELIVERY_BOARD_DELETE'
export const DELIVERY_BOARD_DELETE_SUCCESS = 'operations/DELIVERY_BOARD_DELETE_SUCCESS'
export const DELIVERY_BOARD_DELETE_FAILURE = 'operations/DELIVERY_BOARD_DELETE_FAILURE'
export const CLOSE_MODAL = 'operations/CLOSE_MODAL'
export const UPDATE_ESTIMATED_ARRIVAL_TIME = 'operations/UPDATE_ESTIMATED_ARRIVAL_TIME'
export const UPDATE_ESTIMATED_ARRIVAL_TIME_SUCCESS = 'operations/UPDATE_ESTIMATED_ARRIVAL_TIME_SUCCESS'
export const CALCULATE_ETA_REQUEST = 'operations/CALCULATE_ETA_REQUEST'
export const CALCULATE_ETA_SUCCESS = 'operations/CALCULATE_ETA_SUCCESS'
export const WIPE_BILLABLE_BOARD = 'operations/WIPE_BILLABLE_BOARD'
export const SET_SEARCH_FILTERS = 'operations/SET_SEARCH_FILTERS'
export const CLEAR_SEARCH_FILTERS = 'operations/CLEAR_SEARCH_FILTERS'
export const SET_CURRENT_TAB = 'operations/SET_CURRENT_TAB'

const INITIAL_STATE = {
  deliveries: {},
  isDeliveriesRequestLoading: false,
  isLoading: false,
  isStepTwo: false,
  split: {
    isLoading: false,
    success: false,
  },
  searchFilters: {
    orderGiverName: null,
    courierName: null,
    reference: null,
    comments: null,
  },
  currentTab: null,
}

export function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case DELIVERIES_REQUEST:
      return {
        ...state,
        isLoading: true,
        isDeliveriesRequestLoading: true,
      }
    case DELIVERIES_SUCCESS:
      return {
        ...state,
        deliveries: action.payload.reduce((accu, delivery) => {
          accu[delivery.id] = delivery
          return accu
        }, {}),
        isLoading: false,
        isDeliveriesRequestLoading: false,
      }
    case DELIVERIES_FAILURE:
      return {
        ...state,
        isLoading: false,
        isDeliveriesRequestLoading: false,
      }
    case DELIVERIES_UPDATE:
      return {
        ...state,
        deliveries: {
          ...state.deliveries,
          [action.payload.id]: {
            ...state.deliveries[action.payload.id],
            ...action.payload,
          },
        },
        isLoading: false,
      }
    case DELIVERIES_DELETE:
      return {
        ...state,
        deliveries: state.deliveries.reduce((accu, delivery) => {
          if (delivery.id !== action.payload.id) {
            accu[delivery.id] = delivery
          }
          return accu
        }, {}),
      }
    case DELIVERY_TRANSITION_REQUEST: {
      return {
        ...state,
        deliveries: {
          ...state.deliveries,
          [action.payload.delivery.id]: {
            ...action.payload.delivery,
            operatorState: action.payload.destinationOperatorState,
          },
        },
      }
    }
    case DELIVERY_TRANSITION_SUCCESS: {
      return {
        ...state,
        deliveries: {
          ...state.deliveries,
          [action.payload.id]: {
            ...action.payload,
          },
        },
        isStepTwo: false,
        isLoading: false,
      }
    }
    case DELIVERY_TRANSITION_FAILURE: {
      return {
        ...state,
        deliveries: {
          ...state.deliveries,
          ...action.payload.delivery,
        },
        isStepTwo: false,
        isLoading: false,
      }
    }
    case DELIVERY_MODIFY:
    case DELIVERY_BOARD_MODIFY:
      return {
        ...state,
        isLoading: true,
      }
    case DELIVERY_BOARD_MODIFY_SUCCESS:
    case DELIVERY_MODIFY_SUCCESS:
    case UPDATE_ESTIMATED_ARRIVAL_TIME_SUCCESS:
      return {
        ...state,
        deliveries: {
          ...state.deliveries,
          [action.payload.id]: {
            ...state.deliveries[action.payload.id],
            ...action.payload,
          },
        },
        isLoading: false,
      }
    case DELIVERY_MODIFY_FAILURE:
      return {
        ...state,
        isLoading: false,
      }
    case DELIVERY_BOARD_SPLIT:
      return {
        ...state,
        split: {
          ...state.split,
          isLoading: true,
        },
      }
    case DELIVERY_BOARD_SPLIT_SUCCESS:
      return {
        ...state,
        deliveries: {
          ...state.deliveries,
          [action.payload.id]: {
            ...state.deliveries[action.payload.id],
            ...action.payload,
          },
        },
        isLoading: false,
        split: {
          isLoading: false,
          success: true,
        },
      }
    case DELIVERY_BOARD_SPLIT_FAILURE: {
      return {
        ...state,
        split: {
          isLoading: false,
          success: false,
        },
        isLoading: false,
      }
    }

    case DELIVERY_MODIFY_ADRESSES:
      return {
        ...state,
        isLoading: true,
        isStepTwo: false,
      }
    case DELIVERY_MODIFY_ADRESSES_SUCCESS:
      return {
        ...state,
        deliveries: {
          ...state.deliveries,
          [action.payload.id]: {
            ...state.deliveries[action.payload.id],
            ...action.payload,
          },
        },
        isLoading: false,
        isStepTwo: true,
      }
    case DELIVERY_MODIFY_ADRESSES_FAILURE:
      return {
        ...state,
        isLoading: false,
        isStepTwo: false,
      }
    case CLOSE_MODAL:
      return {
        ...state,
        isLoading: false,
        isStepTwo: false,
      }
    case CALCULATE_ETA_SUCCESS:
      return {
        ...state,
        deliveries: {
          ...state.deliveries,
          [action.payload.id]: {
            ...state.deliveries[action.payload.id],
            ...action.payload,
          },
        },
        isLoading: false,
      }
    case SET_SEARCH_FILTERS:
      return {
        ...state,
        searchFilters: {
          ...state.searchFilters,
          ...action.payload,
        },
      }
    case CLEAR_SEARCH_FILTERS:
      return {
        ...state,
        searchFilters: {
          orderGiverName: null,
          courierName: null,
          reference: null,
          comments: null,
        },
      }
    case SET_CURRENT_TAB:
      return {
        ...state,
        currentTab: action.payload,
      }

    default: {
      return state
    }
  }
}

export const deliveriesRequest = (payload, searchFilters = null) => ({
  type: DELIVERIES_REQUEST,
  payload: payload,
  searchFilters: searchFilters,
})

export const deliveriesSuccess = (payload) => ({
  type: DELIVERIES_SUCCESS,
  payload,
})

export const deliveriesFailure = (errors) => ({
  type: DELIVERIES_FAILURE,
  errors,
})

export const deliveryUpdate = (payload) => ({
  type: DELIVERIES_UPDATE,
  payload,
})

export const deliveryCourierTransitionRequest = (delivery, transition, destinationState) => ({
  type: DELIVERY_COURIER_TRANSITION_REQUEST,
  payload: {
    delivery,
    transition,
    destinationState,
  },
})

export const deliveryCourierTransitionSuccess = (payload) => ({
  type: DELIVERY_COURIER_TRANSITION_SUCCESS,
  payload,
})

export const deliveryCourierTransitionFailure = ({ delivery }) => ({
  type: DELIVERY_COURIER_TRANSITION_FAILURE,
  payload: { delivery },
})

export const deliveryTransitionRequest = (delivery, transition, destinationOperatorState, email, sendEmail) => ({
  type: DELIVERY_TRANSITION_REQUEST,
  payload: {
    delivery,
    transition,
    destinationOperatorState,
    email,
    sendEmail,
  },
})

export const deliveryTransitionSuccess = (payload) => ({
  type: DELIVERY_TRANSITION_SUCCESS,
  payload,
})

export const deliveryTransitionFailure = ({ delivery }) => ({
  type: DELIVERY_TRANSITION_FAILURE,
  payload: { delivery },
})

export const deliveryModify = (payload) => ({
  type: DELIVERY_MODIFY,
  payload,
})

export const deliverySplitBoard = (payload) => ({
  type: DELIVERY_BOARD_SPLIT,
  payload,
})

export const deliverySplitBoardSuccess = (payload) => ({
  type: DELIVERY_BOARD_SPLIT_SUCCESS,
  payload,
})

export const deliverySplitBoardFailure = () => ({
  type: DELIVERY_BOARD_SPLIT_FAILURE,
})

export const deliveryBoardModify = (payload) => ({
  type: DELIVERY_BOARD_MODIFY,
  payload,
})

export const deliveryModifyBoardSuccess = (payload) => ({
  type: DELIVERY_BOARD_MODIFY_SUCCESS,
  payload,
})

export const deliveryModifySuccess = (payload) => ({
  type: DELIVERY_MODIFY_SUCCESS,
  payload,
})

export const deliveryModifyFailure = () => ({
  type: DELIVERY_MODIFY_FAILURE,
})

export const deliveryModifyAdresses = (payload) => ({
  type: DELIVERY_MODIFY_ADRESSES,
  payload,
})

export const deliveryModifyAdressesSuccess = (payload) => ({
  type: DELIVERY_MODIFY_ADRESSES_SUCCESS,
  payload,
})

export const deliveryModifyAdressesFailure = () => ({
  type: DELIVERY_MODIFY_ADRESSES_FAILURE,
})

export const closeModal = () => ({
  type: CLOSE_MODAL,
})

export const deliveryDelete = (payload) => ({
  type: DELIVERY_BOARD_DELETE,
  payload,
})

export const deliveryDeleteSuccess = (payload) => ({
  type: DELIVERY_BOARD_DELETE_SUCCESS,
  payload,
})

export const deliveryDeleteFailure = () => ({
  type: DELIVERY_BOARD_DELETE_FAILURE,
})

export const calculateEta = (payload) => ({
  type: CALCULATE_ETA_REQUEST,
  payload,
})

export const calculateEtaSuccess = (payload) => ({
  type: CALCULATE_ETA_SUCCESS,
  payload,
})

export const updateEstimatedArrivalTimeRequest = (payload) => ({
  type: UPDATE_ESTIMATED_ARRIVAL_TIME,
  payload,
})

export const updateEstimatedArrivalTimeSuccess = (payload) => ({
  type: UPDATE_ESTIMATED_ARRIVAL_TIME_SUCCESS,
  payload,
})

export const wipeBillableBoard = (payload) => ({
  type: WIPE_BILLABLE_BOARD,
  payload,
})

export const setSearchFilters = (filters) => ({
  type: SET_SEARCH_FILTERS,
  payload: filters,
})

export const clearSearchFilters = () => ({
  type: CLEAR_SEARCH_FILTERS,
})

export const setCurrentTab = (tab) => ({
  type: SET_CURRENT_TAB,
  payload: tab,
})

export const epic = combineEpics(
  deliveriesRequestEpic,
  deliveryCourierTransitionEpic,
  deliveryTransitionEpic,
  modifyRequestEpic,
  modifyAdressesRequestEpic,
  modifyRequestBoardEpic,
  splitRequestBoardEpic,
  deleteRequestBoardEpic,
  caculateEtaEpic,
  updateEstimatedTimeOfArrivalEpic,
  wipeBillableBoardEpic,
)

export function deliveriesRequestEpic(action$) {
  return action$.ofType(DELIVERIES_REQUEST).mergeMap((action) =>
    Observable.ajax(operate({ payload: action.payload, searchFilters: action.searchFilters }))
      .map((res) => deliveriesSuccess(res.response))
      .catch((err) => {
        try {
          const errors = [...(err.response.violations || []), ...(err.response.errors || [])].map((e) =>
            typeof e === 'string' ? e : e.message,
          )
          return Observable.of(deliveriesFailure(errors))
        } catch (e) {
          return Observable.of(deliveriesFailure())
        }
      }),
  )
}

export function deliveryCourierTransitionEpic(action$) {
  return action$.ofType(DELIVERY_COURIER_TRANSITION_REQUEST).mergeMap((action) => {
    return (
      Observable.ajax(operatorCourierTransition(action.payload.delivery.id, action.payload.transition))
        // SUCCESS CALLBACK IS HANDLED BY MERCURE
        .mergeMap(() => Observable.empty())
        // .mergeMap((res) => Observable.of(deliveryCourierTransitionSuccess(res.response)))
        .catch(() => {
          return Observable.of(
            alertError("La transition n'a pas été effectuée"),
            deliveryCourierTransitionFailure(action.payload.delivery),
          )
        })
    )
  })
}

export function deliveryTransitionEpic(action$) {
  return action$.ofType(DELIVERY_TRANSITION_REQUEST).mergeMap((action) => {
    return (
      Observable.ajax(
        operatorTransition(
          action.payload.delivery.id,
          action.payload.transition,
          action.payload.email,
          action.payload.sendEmail,
        ),
      )
        // SUCCESS CALLBACK IS HANDLED BY MERCURE
        .mergeMap((res) => Observable.of(deliveryTransitionSuccess(res.response)))
        .catch(() => {
          return Observable.of(
            alertError("La transition n'a pas été effectuée"),
            deliveryTransitionFailure(action.payload.delivery),
          )
        })
    )
  })
}

export function modifyRequestEpic(action$) {
  return action$.ofType(DELIVERY_MODIFY).mergeMap((action) => {
    return Observable.ajax(
      modify({
        params: {
          id: action.payload.id,
        },
        payload: action.payload.body,
      }),
    )
      .mergeMap((res) =>
        Observable.of(deliveryModifySuccess(res.response), alertSuccess('La valeur à bien été modifiée')),
      )
      .catch(() => {
        return Observable.of(alertError("La valeur n'a pas pu être modifiée"), deliveryModifyFailure())
      })
  })
}

export function modifyRequestBoardEpic(action$) {
  return action$.ofType(DELIVERY_BOARD_MODIFY).mergeMap((action) =>
    Observable.ajax(
      modify({
        params: {
          id: action.payload.id,
        },
        payload: action.payload.body,
      }),
    )
      // SUCCESS CALLBACK IS HANDLED BY MERCURE
      .mergeMap(() => Observable.empty())
      // .map((res) => deliveryModifyBoardSuccess(res.response))
      .catch(() => {
        return Observable.of(alertError("La valeur n'a pas pu être modifiée"), deliveryModifyFailure())
      }),
  )
}
export function splitRequestBoardEpic(action$) {
  return action$.ofType(DELIVERY_BOARD_SPLIT).mergeMap((action) =>
    Observable.ajax(
      split({
        params: {
          id: action.payload.id,
        },
        payload: parseDeliverySplitPayload(action.payload.body),
      }),
    )
      // SUCCESS CALLBACK IS HANDLED BY MERCURE
      .map((res) => deliverySplitBoardSuccess(res.response))
      .catch(() => {
        return Observable.of(alertError("La valeur n'a pas pu être modifiée"), deliverySplitBoardFailure())
      }),
  )
}

export function deleteRequestBoardEpic(action$) {
  return action$.ofType(DELIVERY_BOARD_DELETE).mergeMap((action) =>
    Observable.ajax(deleteSegment(action.payload.id))
      // SUCCESS CALLBACK IS HANDLED BY MERCURE
      .map((res) => deliveryDeleteSuccess(res.response))
      .catch(() => {
        return Observable.of(alertError("La valeur n'a pas pu être modifiée"), deliveryDeleteFailure())
      }),
  )
}

export function modifyAdressesRequestEpic(action$) {
  return action$.ofType(DELIVERY_MODIFY_ADRESSES).mergeMap((action) =>
    Observable.ajax(
      modify({
        params: {
          id: action.payload.id,
        },
        payload: action.payload.body,
      }),
    )
      .map((res) => deliveryModifyAdressesSuccess(res.response))
      .catch(() => {
        return Observable.of(alertError("La valeur n'a pas pu être modifiée"), deliveryModifyAdressesFailure())
      }),
  )
}

export function caculateEtaEpic(action$) {
  return action$.ofType(CALCULATE_ETA_REQUEST).mergeMap((action) =>
    Observable.ajax(calculateRoutingETA(action.payload)).map((res) => {
      return calculateEtaSuccess(res.response)
    }),
  )
}

export function updateEstimatedTimeOfArrivalEpic(action$) {
  return action$.ofType(UPDATE_ESTIMATED_ARRIVAL_TIME).mergeMap((action) => {
    return Observable.ajax(updateEstimatedArrivalTime(action.payload)).map((res) => {
      return updateEstimatedArrivalTimeSuccess(res.response)
    })
  })
}

export function wipeBillableBoardEpic(action$) {
  return action$
    .ofType(WIPE_BILLABLE_BOARD)
    .mergeMap((action) => {
      return Observable.ajax(billableToBilled())
    })
    .mergeMap(() => Observable.of(alertSuccess('Le tableau va être vidé.')))
    .catch(() => {
      return Observable.of(alertError("Une erreur a eu lieu pendant l'opération"), deliverySplitBoardFailure())
    })
}
